import { ReviewRating } from "@redotech/redo-model/review/review";
import { array, number, object, string, enum as zEnum } from "zod";

export const getReviewsSummaryByProductId = {
  input: string(),
  output: object({
    rating: number().optional(),
    reviewCountByRating: array(
      object({ rating: zEnum(ReviewRating), count: number() }),
    ),
  }),
};
